import "@/App.css";
import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import useLenis from "@/lib/useLenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import HeroActions from "@/components/HeroActions";
import Manifesto from "@/components/Manifesto";
import Results from "@/components/Results";
import Testimonials from "@/components/Testimonials";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Products from "@/components/Products";
import Experience from "@/components/Experience";
import Salon from "@/components/Salon";
import ClosingCTA from "@/components/ClosingCTA";
import Footer from "@/components/Footer";
import LegalPage from "@/components/legal/LegalPage";
import ServiceGallery from "@/components/gallery/ServiceGallery";
import CookieConsent from "@/components/CookieConsent";
import { LEGAL_DOCS } from "@/data/legal";

function Home() {
    useLenis();
    const location = useLocation();

    // Restore scroll when returning from an inner page, or handle "/#section" deep links.
    useEffect(() => {
        // 1) Returning from a service/inner page — restore the exact position.
        let saved = null;
        try {
            saved = sessionStorage.getItem("ladyart_home_scroll");
        } catch (e) {
            saved = null;
        }
        if (saved !== null) {
            try {
                sessionStorage.removeItem("ladyart_home_scroll");
            } catch (e) {
                /* ignore */
            }
            const y = parseInt(saved, 10) || 0;
            const doScroll = () => {
                if (window.__lenis) window.__lenis.scrollTo(y, { immediate: true });
                else window.scrollTo(0, y);
            };
            requestAnimationFrame(doScroll);
            const t1 = setTimeout(doScroll, 150);
            const t2 = setTimeout(doScroll, 450);
            return () => {
                clearTimeout(t1);
                clearTimeout(t2);
            };
        }

        // 2) Deep link like "/#servicii" (used by the footer from other pages).
        if (location.hash) {
            const id = location.hash;
            const t = setTimeout(() => {
                const el = document.querySelector(id);
                if (!el) return;
                if (window.__lenis) window.__lenis.scrollTo(el, { offset: -10 });
                else el.scrollIntoView({ behavior: "smooth" });
            }, 350);
            return () => clearTimeout(t);
        }
        // 3) Otherwise leave the page at its natural top position.
    }, [location]);

    return (
        <div className="App" style={{ backgroundColor: "var(--bg)" }}>
            <Header />
            <main>
                <Hero />
                <HeroActions />
                <Manifesto />
                <Results />
                <Testimonials />
                <Services />
                <Portfolio />
                <Products />
                <Experience />
                <Salon />
            </main>
            <ClosingCTA />
            <Footer />
        </div>
    );
}

// Jump to top on route change for inner pages. The homepage manages its own
// scroll (restore / hash / natural top), so we skip it here.
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (pathname === "/") return;
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

export default function App() {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/servicii/:slug" element={<ServiceGallery />} />
                <Route
                    path="/politica-confidentialitate"
                    element={<LegalPage doc={LEGAL_DOCS["politica-confidentialitate"]} />}
                />
                <Route
                    path="/politica-cookies"
                    element={<LegalPage doc={LEGAL_DOCS["politica-cookies"]} />}
                />
                <Route
                    path="/termeni-conditii"
                    element={<LegalPage doc={LEGAL_DOCS["termeni-conditii"]} />}
                />
            </Routes>
            <CookieConsent />
        </>
    );
}
